"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _moment = _interopRequireDefault(require("@package/moment"));

var _react = _interopRequireDefault(require("react"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Dates(_ref) {
  var creationDate = _ref.creationDate,
      lastUpdated = _ref.lastUpdated;

  try {
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-locator": "invoice.date",
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['row']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      "data-locator": "invoice.date.created"
    }, (0, _moment["default"])(creationDate).tz('Europe/Moscow').format('DD.MM.YY HH:mm'))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['row']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'comment',
      "data-locator": "invoice.date.updated"
    }, (0, _moment["default"])(lastUpdated).tz('Europe/Moscow').format('DD.MM.YY HH:mm'))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Dates;
exports["default"] = _default;